var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:['promo-label', _vm.promo.className],attrs:{"href":_vm.promo.linkUrl}},[_vm._v("\n\t"+_vm._s(_vm.promo.description)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }